import { Number, Percentage } from "@siteimprove/alfa-css";
import { Real } from "@siteimprove/alfa-math";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
const { either } = Parser;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/opacity}
 */
export default Longhand.of(Number.of(1), either(Number.parse, (Percentage.parse)), (value) => value.map((opacity) => Number.of(Real.clamp(opacity.resolve().value, 0, 1))), { inherits: true });
//# sourceMappingURL=opacity.js.map